import { Text } from '@change/ds-core-ui';

import { Step } from '../components/Step';

import { STEPS_CONFIG } from './constants';
import type { FullPostType } from './types';

export function NextSteps(postType: FullPostType) {
	const steps = STEPS_CONFIG[postType];

	return (
		<section
			aria-label="Next steps"
			className="flex w-full min-w-[250px] flex-grow flex-col gap-4"
			data-testid="next-steps-container"
		>
			<Text className="text-size-heading-xs">Next steps</Text>
			<ol className="flex flex-col gap-4">
				{steps.map((step, index) => (
					<li key={`step-${step.variant}`} className="list-none">
						<Step
							stepLabel={`Step ${index + 1}`}
							label={step.label}
							variant={step.variant}
							data-testid="step-component"
						/>
					</li>
				))}
			</ol>
		</section>
	);
}
